module.exports = __webpack_public_path__ + "assets/img/daboki.0a0da6dd.png";